import { Inscriptions } from "@/shared/logic/api";
import { BaseController } from "@/shared/logic/controller";
import {
  Bus,
  DataInscription,
  EnregistreInscriptionOut,
  ParticipantInscription,
  SchemaPaiement,
  Semaine,
  Sexe
} from "@/shared/logic/types";
import { nullDateString } from "@/shared/logic/utils";
import Axios, { AxiosResponse } from "axios";
import { apiUrl, parsePreselected } from "../shared";

const preselected = parsePreselected();

export class Controller extends BaseController {
  data: DataInscription | null = null;

  async loadData() {
    try {
      const rep: AxiosResponse<DataInscription> = await Axios.get(
        apiUrl(Inscriptions.HandleLoadDataInscriptions),
        { params: { preselected } }
      );
      const data = rep.data;
      (data.initial_inscription.participants || []).forEach(p => {
        p.id_camp = Number(data.preselect_camp);
      });
      this.data = data;
    } catch (err) {
      this.notifications.onAxiosError(err);
    }
  }

  getCamp(idCamp: number) {
    if (this.data == null) return null;
    return (this.data.camps || []).filter(c => c.id == idCamp)[0] || null;
  }

  withAcompte() {
    if (this.data == null) return false;
    let withAcompte = false;
    (this.data.initial_inscription.participants || []).forEach(part => {
      const camp = this.getCamp(part.id_camp);
      if (camp == null) {
        return;
      }
      withAcompte =
        withAcompte || camp.schema_paiement == SchemaPaiement.SPAcompte;
    });
    return withAcompte;
  }

  // prend en compte une éventulle pré-sélection du séjour
  newParticipant(): ParticipantInscription {
    return {
      nom: "",
      prenom: "",
      date_naissance: nullDateString,
      sexe: Sexe.SAucun,
      id_camp: this.data == null ? -1 : Number(this.data.preselect_camp),
      lienid: { valid: false, id: 0, crypted: "" },
      options: {
        bus: Bus.BAucun,
        materiel_ski: {
          need: "",
          mode: "",
          casque: true,
          poids: 0,
          taille: 0,
          pointure: 0
        }
      },
      options_prix: {
        jour: [],
        semaine: Semaine.SComplet,
        statut: 0
      },
      quotient_familial: 0
    };
  }

  async checkMail(mail: string) {
    try {
      const resp: AxiosResponse<{ mail_found: boolean }> = await Axios.get(
        apiUrl(Inscriptions.CheckMail),
        {
          params: {
            mail: mail,
            origin: window.location.href
          }
        }
      );
      return resp.data.mail_found;
    } catch (error) {
      C.notifications.onAxiosError(error);
    }
  }

  async validInscription() {
    if (this.data == null) return;
    try {
      const rep: AxiosResponse<EnregistreInscriptionOut> = await Axios.post(
        apiUrl(Inscriptions.EnregistreInscriptionComplete),
        this.data.initial_inscription
      );
      return rep.data;
    } catch (err) {
      this.notifications.onAxiosError(err);
    }
  }
}

export const C = new Controller();
